import { render, staticRenderFns } from "./PublicOpinion.vue?vue&type=template&id=48860880&scoped=true&"
import script from "./PublicOpinion.vue?vue&type=script&lang=js&"
export * from "./PublicOpinion.vue?vue&type=script&lang=js&"
import style0 from "./PublicOpinion.vue?vue&type=style&index=0&id=48860880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48860880",
  null
  
)

export default component.exports